import i18next from 'i18next';
import translations from '../translations';
import { translate, Replacements } from './translate';
import { resolveLocale } from './resolveLocale';

// ECDEX-3440: drop-in replacement for react-redux-i18n's `I18n.t(key,
// replacements)`, for call sites that can't render `<T>` (attribute values,
// validators, and other non-JSX string lookups). `@international/mastodon-
// i18n`'s `i18n.setLocale()` calls `i18next.changeLanguage()` internally, so
// `i18next.language` (imported directly, not via the `react-i18next` hook) is
// always current -- this works identically inside or outside a React render,
// same as `<T>`'s own resolution, just without the reactivity a component
// needs to know *when* to recompute. Components get that reactivity from
// `useT()` (`hooks/useT.ts`); this plain function is for everything else.
export const t = (key: string, replacements: Replacements = {}): any =>
  translate(translations, resolveLocale(i18next.language), key, replacements);
